import {Pipe, PipeTransform} from '@angular/core';
import {PatientDisplayFormat} from '../enums/patient-display-format.enum';
import {DisplayablePatient, formatPatientName} from '../utilities/patient-name-formatter';

@Pipe({
  name: 'patientName',
})
export class PatientNamePipe implements PipeTransform {
  transform(patient: DisplayablePatient | null | undefined, format: PatientDisplayFormat | null | undefined): string {
    return formatPatientName(patient, format);
  }
}
